<template>
  <transition name="slideDown">
    <div v-if="videoName" class="overlayTutorial">
      <video @click="togglePlay"
             autoplay>
        <source :src="returnVideoPath('assets/video/')"
                type="video/mp4">
      </video>
      <!--
      <div class="overlayTutorial__close">
        <img :src="returnPath('assets/img/svg/close.svg')" alt="" @click.prevent="closeComponent"/>
      </div>
      -->
      <div class="overlayTutorial__play"></div>
    </div>
  </transition>
</template>

<script>
  export default{
    data(){
      return {
        videoName: ''
      }
    },
    methods: {
      returnPath(path){
        return ENV.assetsRoot + path;
      },
      returnVideoPath(path){
        return ENV.assetsRoot + path + this.videoName;
      },
      closeComponent(){
        this.$emit('close-video-overlay');
      },
      togglePlay(e){
        var vm = this;
        var video = e.target;
        var wrapper = document.querySelector('.overlayTutorial');
        vm.toggleClass(wrapper, 'is-playing');
        if (vm.hasClass(wrapper, 'is-playing')) {
          video.play();
        }
        else {
          video.pause();
        }
      }
    },
    mounted() {
      var vm = this;
      vm.videoName = vm.$store.state.currentTutorial;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/OverlayTutorial.vue